<div class="connection-request-container">
  <div class="connection-request">
    <div class="logo">
      <img
        [src]="connectionRequest.logo"
        [alt]="connectionRequest.name"
        width="42px"
        loading="lazy"
      />
    </div>
    <div class="body">
      <div class="subject">
        <span class="company-name" (click)="companyClick($event)">{{
          connectionRequest.name
        }}</span>
        has invited you to connect
      </div>
      <div class="actions">
        <s-button
          type="secondary"
          skin="red"
          size="small"
          iconPos="left"
          [label]="'Decline'"
          [disabled]="!!disableButton()"
          [icon]="
            disableButton() === 'decline' ? 'pi pi-spin pi-spinner' : 'pi pi-check-circle'
          "
          (click)="declineConnectionRequest()"
        ></s-button>
        <s-button
          type="primary"
          skin="green"
          size="small"
          [icon]="
            disableButton() === 'accept' ? 'pi pi-spin pi-spinner' : 'pi pi-check-circle'
          "
          icon="pi pi-check-circle"
          iconPos="left"
          [label]="'Accept'"
          (click)="acceptConnectionRequest()"
          [disabled]="!!disableButton()"
        ></s-button>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog></p-confirmDialog>